module.exports = __webpack_public_path__ + "static/media/delete-icon.d580222e.svg";